import { CircularProgress } from "@mui/material"

export const LoadingPage = () => {
    return (
        <div className="w-full h-screen flex justify-center items-center">
            <CircularProgress />
        </div>
    )
}